// @spec DHB-STR-017
// Route page for OCR extraction review

import { createFileRoute } from '@tanstack/react-router';

import { OcrReviewPage } from '@/features/datahub/uploads/OcrReviewPage';

export const Route = createFileRoute('/_authenticated/datahub/uploads/$uploadId/review')({
  component: ReviewPage,
});

function ReviewPage() {
  const { uploadId } = Route.useParams();

  return <OcrReviewPage uploadId={uploadId} />;
}
